import { useAppSelector } from '../../../../shared/store/hooks';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import UpgradeButtonAtom from '../../atoms/buttons/upgradeButton';
import useList from '../../../../shared/components/utils/hooks/useList';

function UpgradeButton({
  forceFocus,
  height,
  index,
  item,
  margin,
  action,
  releaseAction,
}: {
  height?: number;
  index: number;
  item: string;
  forceFocus?: boolean;
  margin?: string;
  action?: () => void;
  releaseAction?: () => void;
}) {
  const { listIndex, focused } = useList(index);
  const { enabled } = useAppSelector(magicRemoteSelector);
  return (
    <UpgradeButtonAtom
      height={height}
      margin={margin}
      focused={forceFocus || (!enabled && focused && listIndex === index)}
      onClick={action || releaseAction}
      id='upgradeButton'
    >
      {item}
    </UpgradeButtonAtom>
  );
}

export default UpgradeButton;
